<mat-form-field subscriptSizing="dynamic" appearance="outline">
  <mat-label>Route Direction</mat-label>
  <mat-select
    [(value)]="currDirection"
    (selectionChange)="selectionOnChange($event)">
    <mat-option *ngFor="let option of selectOptions" [value]="option.value">
      {{ option.label }}
    </mat-option>
  </mat-select>
</mat-form-field>
